import { useDispatch } from 'react-redux';
import { syncContext } from '@client/context/redux/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useSyncContext = (): typeof syncContext => {
  const dispatch = useDispatch();

  return bindActionCreators(syncContext, dispatch);
};
